// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"FS","tooltipWrapper":"GS","icon":"HS","tooltip":"IS","content":"JS"};